import dayjs from 'dayjs';
import { buildClientSchema } from 'graphql';

import schemaJson from '@/lib/apollo/links/customScalar/gen/graphql.schema.json';
import { dayjst } from '@/lib/dayjst';

import { createScalarLink } from './scalarLink';

export const customScalarLink = createScalarLink(
  buildClientSchema(schemaJson as any),
  {
    Date: {
      serialize: (parsed: unknown) => {
        if (dayjs.isDayjs(parsed)) {
          return parsed.format('YYYY-MM-DD');
        }
        return typeof parsed === 'string' ? parsed : '';
      },
      parseValue: (raw: unknown) => {
        return typeof raw === 'string' && raw ? dayjst(raw) : null;
      },
    },
    Time: {
      serialize: (parsed: unknown) => {
        if (dayjs.isDayjs(parsed)) {
          return parsed.format();
        }
        return typeof parsed === 'string' ? parsed : '';
      },
      parseValue: (raw: unknown) => {
        return typeof raw === 'string' && raw ? dayjst(raw) : null;
      },
    },
  },
);
